import Builder, { initialValues as builderInitialValues } from './Builder';
import Player from './Player';

export default {
    handle: 'logCompliance',
    label: 'Log Compliance',
    builderInitialValues,
    builder: Builder,
    player: Player,
};
